import React from 'react';
import { UserIntegrateTable } from '../tables/UserIntegrateTable';
import { Information } from './common';

export const ChooseUserIntegrateModal = ({
  visible,
  data,
  action,
  onClose,
  multilineText = true,
  buttonText = '閉じる',
  title = '操作ユーザー選択',
  showBtnClose = true,
}) => {
  const getMessage = () => {
    return (
      <div>
        <div className='choose-user-integrate__desc'>
          操作するユーザーを選択してください。
        </div>
        <UserIntegrateTable data={data} action={action} />
      </div>
    );
  };

  return (
    <Information
      rootClassName='choose-user-integrate'
      visible={visible}
      message={getMessage()}
      title={title}
      multilineText={multilineText}
      buttonText={buttonText}
      onClose={onClose}
      showBtnClose={showBtnClose}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ChooseUserIntegrateModal.jsx